import { holidayConstants } from '../constants/holiday.constants';
import holidayService from '../services/holiday.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const holidayActions = {
  create,
  update,
  remove,
  fetch,
  get,
};

function create(obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const holiday = await holidayService.create(obj);
      dispatch(success(holiday));
      dispatch(alertActions.success("Feriado criado"));
      history.push('/settings/holidays');
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: holidayConstants.CREATE_REQUEST } }
  function success(holiday) { return { type: holidayConstants.CREATE_SUCCESS, holiday } }
  function failure(error) { return { type: holidayConstants.CREATE_FAILURE, error } }
}

function update(id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const holiday = await holidayService.update(id, obj);
      dispatch(success(holiday));
      dispatch(alertActions.success("Feriado alterado"));
      history.push('/settings/holidays');
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: holidayConstants.UPDATE_REQUEST } }
  function success(holiday) { return { type: holidayConstants.UPDATE_SUCCESS, holiday } }
  function failure(error) { return { type: holidayConstants.UPDATE_FAILURE, error } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await holidayService.remove(id);
      dispatch(success(true));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: holidayConstants.REMOVE_REQUEST } }
  function success(result) { return { type: holidayConstants.REMOVE_SUCCESS, result } }
  function failure(error) { return { type: holidayConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const holidays = await holidayService.fetch(params);
      dispatch(success(holidays));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: holidayConstants.FETCH_REQUEST } }
  function success(holidays) { return { type: holidayConstants.FETCH_SUCCESS, holidays } }
  function failure(error) { return { type: holidayConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const holiday = await holidayService.get(id);
      dispatch(success(holiday));
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: holidayConstants.GET_REQUEST } }
  function success(holiday) { return { type: holidayConstants.GET_SUCCESS, holiday } }
  function failure(error) { return { type: holidayConstants.GET_FAILURE, error } }
}
